import merge from "@app/utils/merge";

const BaseConfig = {
	DEBUG: false,
	PROXY: "",
	VERSION: "",
	ENV: "dev",
	BASE_PATH: "",
	DANGER_MIN_COUNT: 3,
	API: {
		get BASE_PATH() {
			switch (BaseConfig.ENV) {
				case "prod":
					return "https://backend.arbeitsplatz.tempton.online";
				case "stage":
					return "https://stage-backend.arbeitsplatz.tempton.online";
				case "bbdev":
					return "https://tempton-apb.dev.bippesbrandao.net";
				case "ddev":
					return "https://apb-tempton.ddev.site";
				default:
					return "/api";
			}
		},
		FORM_CONFIG: {
			// CACHE: 1000 * 60 * 60 * 1,
			CACHE: 1000 * 60 * 60 * 24,
			get LOAD() {
				return BaseConfig.API.BASE_PATH + "/arbeitsplatz";
			},
			get LOAD_RISK_ANALYSIS() {
				return BaseConfig.API.BASE_PATH + "/arbeitsplatz/gefaehrdungsanalyse";
			},
			get LOAD_MEASURES_OPTIONS() {
				return BaseConfig.API.BASE_PATH + "/arbeitsplatz?action=getCatalogs";
			},
		},
		USER_OFFICES: {
			// CACHE: 1000 * 60 * 60 * 1,
			CACHE: 1000 * 60 * 60 * 24,
			get LOAD() {
				return BaseConfig.API.BASE_PATH + "?action=getOfficesForUser";
				// return BaseConfig.ENV === "dev"
				// 	? "/test-data/offices.json" // TODO temp fix
				// 	: BaseConfig.API.BASE_PATH + "?action=getOfficesForUser";
			},
		},
		USER: {
			get LOAD() {
				return BaseConfig.API.BASE_PATH + "?action=getUserInfo";
			},
		},
		JOBS: {
			// CACHE: 1000 * 60 * 60 * 1,
			CACHE: 1000 * 60 * 60 * 24,
			get LOAD() {
				return BaseConfig.API.BASE_PATH + "?action=getQualificationsMatrix";
				// return BaseConfig.ENV === "dev"
				// 	? "/test-data/QAMatrix.json" // TODO remove
				// 	: BaseConfig.API.BASE_PATH + "?action=getQualificationsMatrix";
			},
		},
		INSPECTION: {
			// CACHE: 1000 * 60 * 60 * 1,
			CACHE: 1000 * 60 * 60 * 24,
			get LOAD() {
				return BaseConfig.API.BASE_PATH + "?action=getSavedFormDataForOffices";
			},
			get SAVE() {
				return BaseConfig.API.BASE_PATH + "?action=saveFormData";
			},
			get UPDATE() {
				return BaseConfig.API.BASE_PATH + "?action=saveFormData";
			},
			get DELETE() {
				return BaseConfig.API.BASE_PATH + "?action=deleteFormData";
			},
		},
		FEEDBACK: {
			get SAVE() {
				return BaseConfig.API.BASE_PATH + "?action=saveFeedbackData";
			},
		},
	},
	// API_TEST: "/test-data/inspection-config.json",
	FOLLOWUP_TIMESPAN_DEFAULT_MONTH: 12, // 12 month
	FOLLOWUP_REMINDER_OFFSET: 30, // 30 days
	FOLLOWUP_REMINDER_URGENT_OFFSET: 7, // 7 days
	FOLLOWUP_REMINDER_SOON_OFFSET: 14, // 14 days
	FOLLOWUP_MAX_POSTPONEMENT: 30, // 30 days
	CONFIRMATION_DATE_MAX_PAST_DAYS: 28, // 4 weeks
	ACCIDENT_REMINDER_OFFSET: 0, // 0 days
	FIELD_TYPE_MAPPING: {
		text: "string",
		formattedNumber: "string",
		textArea: "string",
		autocomp: "string",
		jobSelector: "string",
		datepicker: "string",
		checkbox: "string",
		checkboxTeaser: "string",
		radio: "string",
		radioGroup: "string",
		radioSwitcher: "string",
		select: "string",
		selectMulti: "array",
		attributeSelector: "array",
		attributeSelectorSingle: "string",
		extendedPropertyList: "array",
		subFormPage: "array",
		repeatableList: "array",
		bodypartSelector: "array",
	},
	ERROR_DEFAULT_MESSAGE: "Bitte füllen Sie dieses Feld aus.",
	ERROR_REQUIRED_MESSAGE: "Bitte füllen Sie dieses Feld aus.",
	ERROR_MATCH_MESSAGE: "Anforderung nicht erfüllt.",
	ERROR_CONFIRMATION_DATE_RANGE_MESSAGE: "Bitte wählen Sie ein Datum zwischen heute − 4 Wochen und heute.",
	ERROR_FOLLOWUP_BEFORE_INSPECTION_MESSAGE:
		"Das Datum der Folgebesichtigung darf nicht vor dem Datum der Begehung liegen.",
};

const Config = merge(BaseConfig, window.Config);
export default Config;
